/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Guides_Analysis_TitleInputs */

const en_gc_guides_analysis_title = /** @type {(inputs: Gc_Guides_Analysis_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft charts and PivotTables: a beginner’s guide`)
};

const zh_gc_guides_analysis_title = /** @type {(inputs: Gc_Guides_Analysis_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft 图表与数据透视表：初学者指南`)
};

/**
* | output |
* | --- |
* | "GridCraft charts and PivotTables: a beginner’s guide" |
*
* @param {Gc_Guides_Analysis_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_guides_analysis_title = /** @type {((inputs?: Gc_Guides_Analysis_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Guides_Analysis_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_guides_analysis_title(inputs)
	return zh_gc_guides_analysis_title(inputs)
});
export { gc_guides_analysis_title as "gc.guides.analysis.title" }